import React from 'react';
import styles from './MarketplaceStatus.module.css';
import backImg from '../../../../assets/images/Fireboard/back2_red.png';

const MarketplaceStatus = (props) => {
  const { onMarketplaceStatusPress, dismissPopup } = props;

  const onTestButtonPress = () => {
    console.log('Marketplace Status - Test Button pressed');
    onMarketplaceStatusPress({
      testButton: true
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.backButton} onClick={dismissPopup}>
        <img src={backImg} className={styles.backImage} alt="" />
      </div>
      <div className={styles.wrapper}>
        <div className={styles.heading}>Marketplace Status</div>
        <div className={styles.btnWrapper}>
          <button className={styles.btns} onClick={() => onTestButtonPress()}>Test Button</button>
        </div>
      </div>
    </div>
  );
}

export default MarketplaceStatus;
